// src/redux/insuranceCorpApi.js
import { apiSlice } from "./apiSlice";
// import qs from "query-string";

export const insuranceCorpApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        // 보험사 업체 조회
        getInsuranceCorp: build.query({
            query: (params) => ({
                url: `/api/user/insurance_corp/v1`,
                method: "get",
                headers: { token: true },
                params: params,
            }),
        }),
    }),
});

export const { useGetInsuranceCorpQuery } = insuranceCorpApi;
